import { useEffect, useState } from 'react';
import type { Page } from '@/components/canvas/document/publicTypes';
import {
  getViewportWorldBounds,
  getVisiblePageIds,
  VIEWPORT_CULL_PADDING,
} from '@/components/canvas/page/pageBounds';

export function useViewportPageVisibility(
  pages: Page[],
  currentPageId: string,
  stageHostRef: React.RefObject<HTMLDivElement | null>,
  panX: number,
  panY: number,
  zoom: number,
): Set<string> {
  const [visibleIds, setVisibleIds] = useState<Set<string>>(() => new Set(pages.map((p) => p.id)));

  useEffect(() => {
    const host = stageHostRef.current;
    if (!host) return;

    const update = () => {
      const w = host.clientWidth;
      const h = host.clientHeight;
      if (w <= 0 || h <= 0) {
        setVisibleIds(new Set(pages.map((p) => p.id)));
        return;
      }
      const viewport = getViewportWorldBounds(w, h, panX, panY, zoom);
      const ids = getVisiblePageIds(pages, viewport, VIEWPORT_CULL_PADDING, zoom);
      ids.add(currentPageId);
      setVisibleIds(ids);
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(host);
    return () => ro.disconnect();
  }, [pages, currentPageId, stageHostRef, panX, panY, zoom]);

  return visibleIds;
}
